import { render } from "./CattleList.vue?vue&type=template&id=0362e038&scoped=true"
import script from "./CattleList.vue?vue&type=script&lang=js"
export * from "./CattleList.vue?vue&type=script&lang=js"

import "./CattleList.vue?vue&type=style&index=0&id=0362e038&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0362e038"]])

export default __exports__